"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconBelowTextButton = void 0;
var _react = require("@linaria/react");
const IconBelowTextButton = exports.IconBelowTextButton = /*#__PURE__*/(0, _react.styled)('div')({
  name: "IconBelowTextButton",
  class: "i1s6t193",
  propsAsIs: false
});